import useNavModel, { RouterParamType } from '@/model/navModel'
import React, { useState } from 'react'
import { AddGoodsModal } from './AddGoodsModal'
import { FormBox } from './FormBox'
import { TableBox } from './TableBox'
export default () => {
    const { getSelectedNavState } = useNavModel(() => [])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    return (
        <>
            <div>询价单详情</div>
            {detailsInfo && (
                <>
                    <FormBox {...detailsInfo} />
                    <TableBox {...detailsInfo} />

                    <AddGoodsModal {...detailsInfo} />
                </>
            )}
        </>
    )
}
